import React, { useState } from 'react';
import { getGradeLabel } from '../utils/gradeUtils';
import ProfileEdit from './ProfileEdit';

/**
 * きょうだい管理画面
 * children: プロフィール一覧
 * isGuest: ゲストモードか
 * isPremium: プレミアムユーザーか
 * onAdd(profile): 追加コールバック
 * onUpdate(id, updates): 更新コールバック
 * onDelete(id): 削除コールバック
 * onBack: もどる
 */
export default function SiblingManage({ children, isGuest, isPremium, onAdd, onUpdate, onDelete, onBack, onUpgrade, onFreeSignup }) {
  const [editTarget, setEditTarget] = useState(null); // null=一覧, 'new'=新規, child=編集
  const [deleteTarget, setDeleteTarget] = useState(null); // 削除確認対象のchild
  // ゲスト:1人、無料ログイン:2人、プレミアム:5人
  const maxChildren = isPremium ? 5 : isGuest ? 1 : 2;
  const canAdd = children.length < maxChildren;

  // ── 編集フォーム ─────────────────────────
  if (editTarget) {
    const isNew = editTarget === 'new';
    return (
      <ProfileEdit
        isGuest={isGuest}
        initialData={isNew ? null : editTarget}
        onSave={async (profile) => {
          if (isNew) {
            await onAdd(profile);
          } else {
            await onUpdate(editTarget.id, profile);
          }
          setEditTarget(null);
        }}
        onCancel={() => setEditTarget(null)}
      />
    );
  }

  // ── 一覧画面 ─────────────────────────────
  return (
    <div className="screen sibling-manage-screen">

      <button className="btn-back" onClick={onBack}>← もどる</button>
      <h2 className="sibling-manage-title">👨‍👧‍👦 きょうだいの管理</h2>

      <div className="sibling-list">
        {children.map((child) => {
          const grade = (child.birth_year && child.birth_month)
            ? getGradeLabel(child.birth_year, child.birth_month)
            : '';
          return (
            <div key={child.id} className="sibling-item">
              <span className="sibling-avatar">{child.avatar || '🐣'}</span>
              <div className="sibling-info">
                <div className="sibling-name">{child.name || 'ゲスト'}</div>
                {grade && <div className="sibling-grade">{grade}</div>}
              </div>
              <button
                className="sibling-edit-btn"
                onClick={() => setEditTarget(child)}
              >✏️ へんしゅう</button>
              {children.length > 1 && (
                <button
                  className="sibling-delete-btn"
                  onClick={() => setDeleteTarget(child)}
                >🗑️</button>
              )}
            </div>
          );
        })}
      </div>

      {/* 追加ボタン */}
      {canAdd ? (
        <button
          className="sibling-add-btn"
          onClick={() => setEditTarget('new')}
        >
          ＋ きょうだいを　ついか
        </button>
      ) : isPremium ? (
        <div className="sibling-limit-note">
          プロフィールは最大{maxChildren}人まで追加できます
        </div>
      ) : isGuest ? (
        <div className="sibling-premium-prompt">
          <p className="sibling-premium-note">
            📱 無料登録すると最大2人まで<br />プロフィールを追加できます
          </p>
          <button
            className="sibling-premium-btn"
            onClick={onFreeSignup || onUpgrade}
          >
            無料でアカウントを作る
          </button>
        </div>
      ) : (
        <div className="sibling-premium-prompt">
          <p className="sibling-premium-note">
            👑 プレミアムなら最大5人まで<br />プロフィールを追加できます
          </p>
          <button
            className="sibling-premium-btn"
            onClick={onUpgrade}
          >
            👑 プレミアムに登録
          </button>
        </div>
      )}

      {/* 削除確認ポップアップ */}
      {deleteTarget && (
        <div className="sibling-delete-overlay" onClick={() => setDeleteTarget(null)}>
          <div className="sibling-delete-modal" onClick={e => e.stopPropagation()}>
            <div className="sibling-delete-icon">🗑️</div>
            <div className="sibling-delete-name">
              {deleteTarget.avatar} {deleteTarget.name}
            </div>
            <p className="sibling-delete-msg">
              このプロフィールを削除しますか？<br />
              <span className="sibling-delete-warn">⚠️ きろくもすべて消えます</span>
            </p>
            <div className="sibling-delete-btns">
              <button className="sibling-delete-cancel" onClick={() => setDeleteTarget(null)}>
                キャンセル
              </button>
              <button className="sibling-delete-confirm" onClick={() => {
                onDelete(deleteTarget.id);
                setDeleteTarget(null);
              }}>
                削除する
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
